import Section from '../Section';

export default class CustomHtml extends Section {

}
